import { AuthLayout } from '../../components/AuthLayout/AuthLayout';
import Page from '../../components/Page/Page';
import { SignUpArea } from '../../sections/auth/SignUpArea';

export default function SignUp() {
  return (
    <Page title="Darum | SignIn">
      <AuthLayout
        formHeaderTitle="Hello"
        formHeaderDescription="Set your password"
      >
        <SignUpArea />
      </AuthLayout>
    </Page>
  );
}
// http://localhost:3000/account/signup/YzJkYTAzYTItZjI0OS00YTE4LWIwNWYtOTAxODNhYjI2NzQ5
